var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarketplace = function SvgMarketplace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.245 18.245",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "shopping-bag (2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.877 5.417h1.069v1.069a.535.535 0 0 1-1.069 0zH1.306a.713.713 0 0 0-.712.673L0 16.741a1.425 1.425 0 0 0 1.423 1.5h5.789a2.5 2.5 0 0 1-.442-1.6l.424-6.008A1.78 1.78 0 0 1 8.971 8.98h2.445l-.161-2.89a.713.713 0 0 0-.712-.673H9.148V3.136a3.136 3.136 0 1 0-6.272 0Zm1.069-2.281a2.067 2.067 0 1 1 4.134 0v2.281h1.068v1.069a.535.535 0 0 1-1.069 0V5.417H3.946Z",
    "data-name": "Pfad 3307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.242 16.72-.424-6.008a.713.713 0 0 0-.711-.663H8.971a.713.713 0 0 0-.711.663l-.424 6.008a1.425 1.425 0 0 0 1.422 1.526h7.562a1.425 1.425 0 0 0 1.422-1.526m-3.209-3.886a2.062 2.062 0 1 1-4.124 0v-.646a.535.535 0 1 1 1.069 0v.646a.993.993 0 1 0 1.985 0v-.646a.535.535 0 1 1 1.069 0Z",
    "data-name": "Pfad 3308"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarketplace);
export default ForwardRef;